import React from "react";
import { ArrowRight, Calendar, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { createPageUrl } from "../../utils";
import { useLanguage } from "../../i18n";

export default function UpcomingEvents() {
  const { t } = useLanguage();
  const events = t("home.events", []);
  const featuredEvents = events.slice(0, 3);

  if (featuredEvents.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-[#f7f1e8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="font-serif-elegant text-3xl font-bold text-[#722F37]">
              {t("home.parishLife")}
            </h2>
            <p className="text-gray-600 text-sm max-w-xl">
              {t("home.parishLifeBody")}
            </p>
          </div>
          <Link
            to={createPageUrl("Events")}
            className="inline-flex items-center gap-2 text-sm text-[#722F37] hover:text-[#C9A227]"
          >
            {t("home.viewAll")}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {featuredEvents.map((event) => (
            <div
              key={`${event.title}-${event.dateLabel}`}
              className="bg-white rounded-3xl p-6 shadow-sm border border-[#C9A227]/10 flex flex-col gap-4"
            >
              <div className="text-xs text-gray-500 flex items-center gap-2 uppercase tracking-[0.16em]">
                <Calendar className="w-4 h-4 text-[#C9A227]" />
                <span>{event.dateLabel}</span>
                {event.time && <span>• {event.time}</span>}
              </div>
              <h3 className="font-serif-elegant text-lg font-bold text-[#722F37]">
                {event.title}
              </h3>
              <p className="text-sm font-medium text-[#C9A227]">{event.category}</p>
              <p className="text-sm text-gray-600">{event.description}</p>
              {event.location && (
                <p className="mt-auto text-xs text-gray-500 flex items-center gap-1">
                  <MapPin className="w-3 h-3 text-[#C9A227]" />
                  {event.location}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
